import clsx from "clsx";
import type { ComponentProps } from "react";

const base =
  "inline-flex items-center justify-center gap-1.5 rounded-lg border whitespace-nowrap transition-colors disabled:pointer-events-none disabled:opacity-45";
const variants = {
  primary: "border-orange bg-orange font-semibold text-ink hover:border-orange-deep hover:bg-orange-deep",
  secondary: "border-line-strong bg-surface font-medium text-ink hover:border-green hover:text-green-ink",
  ghost: "border-transparent bg-transparent font-medium text-ink-2 hover:bg-green-wash hover:text-green-ink",
  danger: "border-line-strong bg-surface font-medium text-danger hover:border-danger hover:bg-danger-wash",
} as const;
const sizes = { sm: "h-7.5 px-2.5 text-sm", md: "h-9 px-3.5 text-base" } as const;

type Look = { variant?: keyof typeof variants; size?: keyof typeof sizes };

/** The button's classes, for a link that must look like a button: `<Link className={buttonClass({ variant: "primary" })}>`. */
export function buttonClass({ variant = "secondary", size = "md" }: Look = {}, className?: string): string {
  return clsx(base, variants[variant], sizes[size], className);
}

export function Button({ variant, size, className, type = "button", ...props }: ComponentProps<"button"> & Look) {
  return <button type={type} {...props} className={buttonClass({ variant, size }, className)} />;
}
